import React from 'react';
import { ChevronUp, ChevronDown } from 'lucide-react';

export default function Table({ columns, rows, renderCell, caption, className = '', sort, onSort, onRowClick, getRowClassName }) {
  React.useEffect(() => {
    // Force le body et html à overflow-x: visible pour éviter le scroll global
    document.body.style.overflowX = 'visible';
    document.documentElement.style.overflowX = 'visible';
    return () => {
      document.body.style.overflowX = '';
      document.documentElement.style.overflowX = '';
    };
  }, []);

  const handleSort = (key) => {
    if (onSort) {
      onSort(key);
    }
  };

  const getSortIcon = (columnKey) => {
    if (!sort || sort.key !== columnKey) {
      return null;
    }
    return sort.dir === 'asc' ? <ChevronUp size={16} /> : <ChevronDown size={16} />;
  };

  const alignClass = (col) => {
    const a = col.align || 'left';
    return a === 'center' ? 'text-center' : a === 'right' ? 'text-right' : 'text-left';
  };

  return (
    <div className={`w-full max-w-screen overflow-x-auto overflow-y-hidden rounded-xl border border-blue-gray-100 bg-white ${className}`} tabIndex={0}>
      <table className="min-w-[800px] w-full border-separate border-spacing-0">
        {caption && <caption className="sr-only">{caption}</caption>}
        <thead>
          <tr className="bg-blue-gray-50/80 text-blue-gray-600 sticky top-0 z-10">
            {columns.map((col, i) => (
              <th
                key={col.key || i}
                scope="col"
                className={`px-3 py-2.5 font-medium text-xs uppercase tracking-wider ${alignClass(col)} ${col.className || ''} ${i === 0 ? 'rounded-tl-xl' : ''} ${i === columns.length - 1 ? 'rounded-tr-xl' : ''} ${onSort && col.key !== 'detail' && !col.renderHeader ? 'cursor-pointer hover:bg-blue-gray-100/80 select-none' : ''}`}
                onClick={() => onSort && col.key !== 'detail' && !col.renderHeader && handleSort(col.key)}
              >
                {col.renderHeader ? (
                  col.renderHeader()
                ) : (
                  <div className={`flex items-center gap-0.5 ${col.align === 'right' ? 'justify-end' : col.align === 'center' ? 'justify-center' : 'justify-start'}`}>
                    {col.label}
                    {getSortIcon(col.key)}
                  </div>
                )}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.length === 0 ? (
            <tr>
              <td colSpan={columns.length} className="text-blue-gray-400 text-center py-10 text-sm">
                Aucune donnée
              </td>
            </tr>
          ) : (
            rows.map((row, i) => (
              <tr
                key={row.url || i}
                className={`border-b border-blue-gray-100 last:border-b-0 transition-colors hover:bg-blue-gray-50/50 ${i % 2 === 0 ? 'bg-white' : 'bg-blue-gray-50/30'} ${onRowClick ? 'cursor-pointer' : ''} ${getRowClassName ? getRowClassName(row, i) || '' : ''}`}
                onClick={() => onRowClick && onRowClick(row)}
              >
                {columns.map((col, j) => (
                  <td
                    key={col.key || j}
                    className={`px-3 py-2.5 align-middle text-sm ${alignClass(col)} ${col.className || ''} ${j === 0 ? 'min-w-0 max-w-[280px] truncate' : ''}`}
                  >
                    {renderCell(row, col, i, j)}
                  </td>
                ))}
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
} 